import { Component, OnInit } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Router } from '@angular/router';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { MessageorderModel } from 'projects/core/src/lib/models/messageorder.model';

@Component({
  selector: 'app-messageorder-list',
  templateUrl: './messageorder-list.component.html',
  styleUrls: ['./messageorder-list.component.scss']
})
export class MessageordersListComponent extends BaseList implements OnInit {

  public messageorders: Array<MessageorderModel> = [];
  public apiUrl = '/messageorders';

  protected rightLoad = 'admin.messageorder.list';
  protected rightNew = 'admin.messageorder.create';
  protected rightOpen = 'admin.messageorder.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('messageorders').subscribe({
      next: (result: any) => {
        this.messageorders = result.data.map((ac: any) => {
          return new MessageorderModel().deserialize(ac);
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
